// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__3kZO2","sidebar__header":"Sidebar_sidebar__header__1Q5Qq","sidebar__footer":"Sidebar_sidebar__footer__w6a4V"};